import { ChevronDown, LayoutDashboard, Building2, LogOut } from "lucide-react"
import { useLocation, useNavigate } from "react-router-dom"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"
import { useAuthStore } from "@/stores/authStore"
import { useOrgStore } from "@/stores/orgStore"
import { ADMIN_EMAIL } from "@/lib/constants"

export function ProfileDropdown() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { user, signOut } = useAuthStore()
  const { currentOrg } = useOrgStore()

  const isAdminRoute = pathname.startsWith("/admin")
  const isAdmin = user?.email === ADMIN_EMAIL

  const handleSignOut = async () => {
    await signOut()
    navigate("/login")
  }

  const contextLabel = isAdminRoute
    ? "Admin Dashboard"
    : currentOrg?.name
      ? `${currentOrg.name} Dashboard`
      : "Dashboard"

  if (!user?.email) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <span className="max-w-[200px] truncate text-gray-700">
            {user.email}
          </span>
          <ChevronDown className="h-4 w-4 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[240px]">
        <DropdownMenuItem disabled className="text-xs text-muted-foreground">
          {contextLabel}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {!isAdminRoute && isAdmin && (
          <DropdownMenuItem
            onSelect={() => navigate("/admin")}
            className="cursor-pointer"
          >
            <LayoutDashboard className="h-4 w-4" />
            Switch to Admin
          </DropdownMenuItem>
        )}
        {isAdminRoute && (
          <DropdownMenuItem
            onSelect={() => navigate("/dashboard")}
            className="cursor-pointer"
          >
            <Building2 className="h-4 w-4" />
            Switch to Organization
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onSelect={(e) => {
            e.preventDefault()
            handleSignOut()
          }}
          className="cursor-pointer text-red-600 focus:text-red-600"
        >
          <LogOut className="h-4 w-4" />
          Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
